import { render, staticRenderFns } from "./AdminNavbar.vue?vue&type=template&id=804eeb5a&scoped=true&"
import script from "./AdminNavbar.vue?vue&type=script&lang=js&"
export * from "./AdminNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AdminNavbar.vue?vue&type=style&index=0&id=804eeb5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804eeb5a",
  null
  
)

export default component.exports